import { render, staticRenderFns } from "./PayHandle.vue?vue&type=template&id=4bc1641c"
import script from "./PayHandle.js?vue&type=script&lang=js&external"
export * from "./PayHandle.js?vue&type=script&lang=js&external"
import style0 from "./PayHandle.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports